var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"height":"medium","width":"large"}},[_c('div',{staticClass:"container"},[_c('h2',{staticClass:"heading"},[_vm._v(_vm._s(_vm.$t('modals.patient.tab.label_two')))]),_c('document-tab',{on:{"toggle":_vm.toggleTab}}),_c('document-tab-content',{attrs:{"physician":{
                ViewTab: _vm.isViewTabActive,
                UploadTabs: _vm.isUploadTabActive,
            }},on:{"toggle":_vm.toggleTab}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }